// extracted by mini-css-extract-plugin
export default {"tags":"tags--vodkD chip--LP2Nn","tags__content":"tags__content--nchpn text-ellipsis--qhQVS","tagsContent":"tags__content--nchpn text-ellipsis--qhQVS"};